export const AccountErrorTypes = [
  { code: 'auth/user-not-verified', value: 'user-not-verified' },
  { code: 'auth/user-not-found', value: 'user-not-found' },
  { code: 'auth/wrong-password', value: 'wrong-password' },
  { code: 'auth/email-already-in-use', value: 'email-already-in-use' },
  { code: 'auth/invalid-action-code', value: 'invalid-action-code' }
]
